import * as types from '../../../actions';

const initialState = {
    items: [],
    status:0,   
    activity:''  
};
export default function(state = initialState, action) {
    const response = action.response;
    switch(action.type) {
        case types.OMNU_POINTS_LIST_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items: response.data,
                    status: response.status,
                    activity:types.OMNU_POINTS_LIST_SUCCESS
                };
            }else{
                return {
                    ...state,
                    status: response.status,
                    activity:types.OMNU_POINTS_LIST_ERROR                                 
                };
            }         
        
        case types.OMNU_POINTS_SAVE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items: response.data,
                    status: response.status,
                    activity:types.OMNU_POINTS_SAVE_SUCCESS
                }    
            }else{
                return {
                    ...state,
                    status: response.status,
                    activity:types.OMNU_POINTS_SAVE_ERROR
                }    
            }
        case types.CLEAR:
            return {
                ...state,
                status:0,   
                activity:''              
            }  

        default:
            return state;
    }
  };